export const SET_STATES = 'SET_STATES';
export const SET_STATE = 'SET_STATE';
export const ADD_STATE = 'ADD_STATE';
export const ADD_STATES = 'ADD_STATES';
export const UPDATE_STATE = 'UPDATE_STATE';
export const REMOVE_STATE = 'REMOVE_STATE';
export const CLEAR_STATE = 'CLEAR_STATE';
export const CLEAR_STATES = 'CLEAR_STATES';
